import { Button } from '@popsure/dirty-swan';
import classNames from 'classnames';
import { useSafeTranslation } from 'shared/i18n';
import {
  capitalizeName,
  capitalizeNameSplit,
} from 'shared/util/capitalizeName';

import styles from './Account.module.scss';

interface Props {
  handleContinue: () => void;
  handleCreateNewAccount?: () => void;
  email: string;
  name: {
    firstName: string;
    lastName: string;
  };
}

const Account = ({
  handleContinue,
  handleCreateNewAccount,
  name,
  email,
}: Props) => {
  const { t } = useSafeTranslation();

  return (
    <div className={styles.container}>
      <div className="p-body">
        <h1 className="p-h1 mt16">
          {t('components.account.title', 'Do you want to continue as')}{' '}
          <span className="tc-primary-500">{capitalizeName(name)}</span>?
        </h1>
        <div className="p-p mt8">
          {t(
            'components.account.subtitle.loggedInWith',
            'You are logged in with'
          )}{' '}
          <span className="fw-bold">{email}</span>
        </div>
        <div>
          <Button
            className={`wmn3 mr8 mt16 ${styles.button}`}
            onClick={handleContinue}
            data-cy="button-account-continue"
          >
            {t('components.account.continueas', 'Continue as')}
            {` ${capitalizeNameSplit(name)[0]}`}
          </Button>
          <Button
            className={`wmn3 mt16 ${classNames(
              styles.button,
              styles.buttonRight
            )}`}
            onClick={handleCreateNewAccount}
            variant="filledWhite"
          >
            {t(
              'components.account.chooseAnotherAccount',
              'Choose another account'
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Account;
